import { ImportFromTextEventAdapter } from '~analytics/adapters/ImportFromTextEventAdapter';

import localAxios from '../localAxios';
import { Order, Question } from '../responses';
import { importFromTextURL } from './urls';

interface ImportFromTextParams {
  quizId: number;
  workspaceId?: string;
  workspaceQuizId?: string;
  insertionOrder: number;
  textQuestions: string;
}

interface QuestionResponse {
  questions: Question[];
  orders: Order[];
}

export interface ImportFromTextResponse {
  result: QuestionResponse;
  elapsedTime: number;
  version: string;
  usage: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
}

export async function importFromText({
  quizId,
  workspaceId,
  workspaceQuizId,
  insertionOrder,
  textQuestions,
}: ImportFromTextParams) {
  const importURL = importFromTextURL(quizId);

  const {
    data: { result, version, elapsedTime, usage },
  } = await localAxios.post<ImportFromTextResponse>(importURL.href, {
    workspaceId,
    workspaceQuizId,
    textQuestions,
    insertionOrder,
  });

  // Analytics
  new ImportFromTextEventAdapter({
    numQuestions: result.questions.length,
    promptLength: textQuestions.length,
    version: version,
    responseMilliseconds: elapsedTime,
    promptTokens: usage.promptTokens,
    completionTokens: usage.completionTokens,
    totalTokens: usage.totalTokens,
  }).sendAnalytics();

  return {
    questions: result.questions,
    orders: result.orders,
    elapsedTime: elapsedTime,
    version: version,
  };
}
